import { get, post } from '../client';

/** Public vendor self-registration + portal helpers. */
export const publicVendorApi = {
  registrationStatus: () => get('/public/vendors/registration-status'),
  register: (body) => post('/public/vendors/register', body),
  documentPresign: (body) => post('/public/vendors/documents/presign', body),
  documentConfirm: (body) => post('/public/vendors/documents/confirm', body),
  /** Portal bootstrap — path token only, no staff bearer. */
  portalBootstrap: (token) => get(`/vendor-portal/token/${token}/bootstrap`),
  portalProfile: (portalToken) =>
    get('/vendor-portal/profile', {
      headers: { 'X-Portal-Token': portalToken },
    }),
  portalIndents: (portalToken, params) =>
    get('/vendor-portal/indents', {
      params,
      headers: { 'X-Portal-Token': portalToken },
    }),
  portalIndentById: (portalToken, id) =>
    get(`/vendor-portal/indents/${id}`, {
      headers: { 'X-Portal-Token': portalToken },
    }),
  createPortalIndent: (portalToken, body) =>
    post('/vendor-portal/indents', body, {
      headers: { 'X-Portal-Token': portalToken },
    }),
  releasePortalIndent: (portalToken, id, body) =>
    post(`/vendor-portal/indents/${id}/release`, body, {
      headers: { 'X-Portal-Token': portalToken },
    }),
  tokenProfile: (token) => get(`/vendor-portal/token/${token}/profile`),
  tokenIndents: (token, params) =>
    get(`/vendor-portal/token/${token}/indents`, { params }),
  tokenIndentById: (token, id) =>
    get(`/vendor-portal/token/${token}/indents/${id}`),
  createTokenIndent: (token, body) =>
    post(`/vendor-portal/token/${token}/indents`, body),
  assignTokenIndent: (token, id, body) =>
    post(`/vendor-portal/token/${token}/indents/${id}/assign`, body),
  releaseTokenIndent: (token, id, body) =>
    post(`/vendor-portal/token/${token}/indents/${id}/release`, body),
};
